import type { ReactElement } from 'react';
import { Plus } from 'lucide-react';
import { ExternalLink } from '@fastnorth/kraken/components/navigation';
import { Div } from '@fastnorth/kraken/components/layout';
import { useResponsive } from '@fastnorth/kraken/components/page-layout';
import { useTranslation } from 'react-i18next';
import { useSubEvent } from '../../../../../../hooks/SubEventProvider.tsx';
import { ResultType } from '@fastnorth/timer-api';
import getEnvUrlPrefix from '../../../../../../utils/getEnvUrlPrefix.ts';
import { useParams } from 'react-router-dom';
import type { KarwaUrlParams } from '../../../../../types.ts';
import { useShouldShowPostButton } from './hooks/useShouldShowPostButton';

const PostVirtualResult = (): ReactElement | null => {
  const { subEvent } = useSubEvent();
  const {
    t,
    i18n: { language: locale },
  } = useTranslation();
  const { isMobile } = useResponsive();
  const { eventUniqueCode } = useParams<KarwaUrlParams>();
  const shouldShow = useShouldShowPostButton();

  if (!shouldShow) {
    return null;
  }

  const isVirtualRace = subEvent?.resultsType === ResultType.VIRTUAL;

  // Build link based on type (only once visibility is guaranteed)
  const postResultLink = isVirtualRace
    ? `${getEnvUrlPrefix()}/${locale}/virtual-event/publish?event=${eventUniqueCode}&resultSubEventId=${subEvent?.id}`
    : `${getEnvUrlPrefix()}/${locale}/virtual-challenges/${subEvent?.id}?target=post_activity`;

  const buttonLabel = isVirtualRace
    ? t('karwa.details.post_virtual_result_button_label')
    : t('karwa.details.post_activity_button_label');

  return (
    <Div className={`${isMobile ? 'w-full' : 'w-fit'}`}>
      <ExternalLink
        href={postResultLink}
        target="_blank"
        variant="pill"
        accent="primary"
        width="full"
        id="donate-button">
        <Plus role="presentation" size={16} className={'mr-3'} />
        {buttonLabel}
      </ExternalLink>
    </Div>
  );
};

export default PostVirtualResult;
